import {PageWithoutFooter} from "../Page";
import {useAuth} from "../../components/auth/AuthContext";
import {OAuthStore, UserAccountStore} from "../../components/auth/store";
import {Button, Text} from "@wakelet/ui-kit";
import {useNavigate} from "react-router";
import {auth} from "../../firebase/firebase-config";
import {useSwitchAccount} from "../../components/switch-account/switch-account-store";

export const OAuthDevPage = () => {
  const navigate = useNavigate();
  const {user} = useAuth();
  const {isSwitching, clearSwitchAccount} = useSwitchAccount();

  const sessionId = OAuthStore.getSession();
  return <PageWithoutFooter>
    <Text.Heading level={1}>OAuth Dev Page</Text.Heading>
    <div className="grid grid-cols-2 gap-2">

      <div>user</div>
      {user && <div>{user?.uid}, {user?.displayName}, {user?.email}</div>}
      {!user && <div>no user</div>}

      <div>session</div>
      <div>{sessionId}</div>

      <div>switching account</div>
      <div>
        {isSwitching && <Text>Yes, switching account</Text>}
        {!isSwitching && <Text>No, not switching account</Text>}
      </div>
    </div>
    <div>

    </div>
    <div>
      <div className="mt-5">
        <Button variant="primary" block onClick={() => auth.signOut()}>Logout</Button>
      </div>
      <div className="mt-5">
        <Button variant="secondary" block onClick={() => UserAccountStore.clear()}>Clear User
          Accounts</Button>
      </div>
      <div className="mt-5">
        <Button variant="secondary" block onClick={() => clearSwitchAccount()}>Clear Switching
          Accounts</Button>
      </div>
      <div className="mt-5">
        <Button block onClick={() => navigate("/oauth/start&dev=true")}><Button.Label
            text={"OAuth Start"}/></Button>
      </div>
      <div className="mt-5">
        <Button block onClick={() => navigate("/oauth/end?dev=true")}><Button.Label text={"OAuth End"}/></Button>
      </div>
    </div>
  </PageWithoutFooter>
};